import { withPreRenderSettings } from '@/utils/hocs';
import { ShopViewPageView } from '@/views/Shops/Shop.view';
import type { ShopDetails } from '@/api/types/shop.types';
import { getSeoFullData } from '@/api/helpers/seo.helpers';
import { getServerShopDetails } from '@/api/helpers/shop.helpers';
import { ServerDataProvider } from '@/contexts/ServerDataContext';

interface Props {
  shopDetails: ShopDetails | null;
}

function ShopPage({ shopDetails }: Props) {
  return (
    <ServerDataProvider adDetails={null}>
      <ShopViewPageView shopDetails={shopDetails ?? undefined} />
    </ServerDataProvider>
  );
}

ShopPage.getInitialProps = withPreRenderSettings(async (context, client) => {
  const seoFullData = await getSeoFullData(client, context);
  const shopDetails = await getServerShopDetails(client, context);

  if (!shopDetails && context.res) {
    context.res.statusCode = 404;
  }

  return {
    seoFullData: seoFullData ?? null,
    shopDetails: shopDetails ?? null,
  };
});

export default ShopPage;
